var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLayouts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.47,
    height: 20,
    viewBox: "0 0 17.47 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layouts",
    transform: "translate(-4503 -9447)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2128",
    "data-name": "Path 2128",
    d: "M3,15.857H.857A.858.858,0,0,1,0,15V.857A.858.858,0,0,1,.857,0H9a.858.858,0,0,1,.857.857v3h-6A.858.858,0,0,0,3,4.714V15.857Z",
    transform: "translate(4503 9447)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_2127",
    "data-name": "Path 2127",
    transform: "translate(4511.488 9455.821)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.781,0H8.2a.71.71,0,0,1,.781.6v9.97a.71.71,0,0,1-.781.6H.781a.71.71,0,0,1-.781-.6V.6A.71.71,0,0,1,.781,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.9999966621398926 0.999995231628418 L 0.9999966621398926 10.17871379852295 L 7.981936931610107 10.17866706848145 L 7.981936931610107 0.999995231628418 L 0.9999966621398926 0.999995231628418 M 0.781036376953125 -4.76837158203125e-06 L 8.200897216796875 -4.76837158203125e-06 C 8.632246971130371 -4.76837158203125e-06 8.981936454772949 0.2705354690551758 8.981936454772949 0.6042556762695313 L 8.981936454772949 10.57445526123047 C 8.981936454772949 10.90817546844482 8.632246971130371 11.17871570587158 8.200897216796875 11.17871570587158 L 0.781036376953125 11.17871570587158 C 0.3496866226196289 11.17871570587158 -2.86102294921875e-06 10.90817546844482 -2.86102294921875e-06 10.57445526123047 L -2.86102294921875e-06 0.6042556762695313 C -2.86102294921875e-06 0.2705354690551758 0.3496866226196289 -4.76837158203125e-06 0.781036376953125 -4.76837158203125e-06 Z",
    stroke: "none",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2133",
    "data-name": "Path 2133",
    d: "M3,14.75H.857a.83.83,0,0,1-.857-.8V.8A.83.83,0,0,1,.857,0H9a.83.83,0,0,1,.857.8V3.588h-6a.83.83,0,0,0-.857.8V14.75Z",
    transform: "translate(4507.807 9451.25)",
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayouts);
export default __webpack_public_path__ + "static/media/Layouts.4c257dc95e8fb8d65293715429b4d76f.svg";
export { ForwardRef as ReactComponent };